function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M70 52.5C70 54.5628 69.1806 56.5411 67.7219 57.9997C66.2633 59.4584 64.285 60.2778 62.2222 60.2778H7.77778C5.71498 60.2778 3.73667 59.4584 2.27806 57.9997C0.819442 56.5411 0 54.5628 0 52.5V46.6667C0 44.6039 0.819442 42.6256 2.27806 41.167C3.73667 39.7084 5.71498 38.8889 7.77778 38.8889H62.2222C64.285 38.8889 66.2633 39.7084 67.7219 41.167C69.1806 42.6256 70 44.6039 70 46.6667V52.5Z",
  fill: "#FE5755"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.9444 25.2777L35.0408 23.3333H13.895C7.77778 23.3333 5.83333 27.2221 5.83333 27.2221L0 38.8091V48.611H36.9444V25.2777Z",
  fill: "#E33D3B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.4998 38.8888H3.88867L7.77756 31.1111C7.77756 31.1111 9.72201 27.2222 13.6109 27.2222H17.4998V38.8888Z",
  fill: "#003E81"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.5004 68.0556C21.796 68.0556 25.2782 64.5733 25.2782 60.2778C25.2782 55.9822 21.796 52.5 17.5004 52.5C13.2049 52.5 9.72266 55.9822 9.72266 60.2778C9.72266 64.5733 13.2049 68.0556 17.5004 68.0556Z",
  fill: "#292F33"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.5002 64.1667C19.648 64.1667 21.3891 62.4256 21.3891 60.2778C21.3891 58.13 19.648 56.3889 17.5002 56.3889C15.3524 56.3889 13.6113 58.13 13.6113 60.2778C13.6113 62.4256 15.3524 64.1667 17.5002 64.1667Z",
  fill: "#043E7D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.5004 68.0556C56.796 68.0556 60.2782 64.5733 60.2782 60.2778C60.2782 55.9822 56.796 52.5 52.5004 52.5C48.2049 52.5 44.7227 55.9822 44.7227 60.2778C44.7227 64.5733 48.2049 68.0556 52.5004 68.0556Z",
  fill: "#292F33"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.5002 64.1667C54.648 64.1667 56.3891 62.4256 56.3891 60.2778C56.3891 58.13 54.648 56.3889 52.5002 56.3889C50.3524 56.3889 48.6113 58.13 48.6113 60.2778C48.6113 62.4256 50.3524 64.1667 52.5002 64.1667Z",
  fill: "#043E7D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.2218 15.5557H33.0551C30.9923 15.5557 29.014 16.3751 27.5554 17.8337C26.0968 19.2923 25.2773 21.2706 25.2773 23.3334V48.6112H69.9996V23.3334C69.9996 21.2706 69.1801 19.2923 67.7215 17.8337C66.2629 16.3751 64.2846 15.5557 62.2218 15.5557Z",
  fill: "#043E7D"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 70,
  height: 70,
  fill: "white"
})));

function SvgDeliveryTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 69,
    viewBox: "0 0 70 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryTruck);
export default __webpack_public_path__ + "static/media/deliveryTruck.0deb4ff4.svg";
export { ForwardRef as ReactComponent };